import { TdsModal, TdsButton } from '@scania/tegel-react';
import { observer } from 'mobx-react';

interface ConfirmationDialogProps {
  onCancel: () => void;
  onConfirm: (confirmed: boolean) => void;
  onReset?: () => void; // Optional reset function
}

const ConfirmationDialog = ({ onCancel, onConfirm, onReset}: ConfirmationDialogProps) => {

  return (
    <TdsModal
      header="Confirm to change Variable type"
      selector=".confirm-dialog"
      id="confirm-dialog"
      size="sm"
      actions-position="static"
      show
    >
      <span slot="body">
        <h4>Are you sure you want to change the variable type.</h4>
        <p>
          <strong>NOTE :</strong> Fields in the form will be reset except for{" "}
          <strong>
            Minimum CDC version, Variable name, Current status name, RFMS name,
            Description & unit
          </strong>
        </p>
      </span>
      <span slot="actions" className="tds-u-flex tds-u-gap2">
        <TdsButton variant="secondary" text="cancel " size="sm" onClick={onCancel} />
        <TdsButton type="button" variant="primary" text="Confirm" size="sm" onClick={() => onConfirm(true)}/>
      </span>
    </TdsModal>
  );
};

export default  observer(ConfirmationDialog)